
import {
    Box,
    Card,
    CardContent,
    Switch,
    Typography,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import { Trans } from 'react-i18next';
import { Context } from '../../context/context';
import api from '../../api';

function EditFlexTimeAccountPage() {
    const [{ user },] = useContext(Context);
    const [institute, setInstitute] = useState(null);

    useEffect(() => {
        if (user.id !== '') {
            api.readInstitute(user.institute).then(res => setInstitute(res));
        };
    }, [user]);

    const handleSwitchAllowFlexTimeAccountsDefault = (allow) => {
        api.updateInstitute(institute.name, {
            ...institute,
            allowFlexTimeAccountsDefault: allow,
        }).then(res => {
            api.readInstitute(user.institute).then(res => setInstitute(res));
        });
    };

    return (
        <>
            <Card sx={{ width : '700px' , p: 3 }}>
                <CardContent>
                    <Typography variant="h5"><Trans i18nKey="defaultTimeSettings" ns="instituteConfigurationPage">Standardeinstellung Arbeitszeitkonto</Trans></Typography>
                    <Box>
                        <Typography sx={{ pt: 2 }}>
                            <Trans i18nKey="defaultTimeSettingsSubTitle" ns="instituteConfigurationPage">In der Stammdatenverwaltung können Sie für jeden Mitarbeiter festlegen, ob die Funtkionen zur Erfassung von Über- und Minusstunden aktiviert werden sollen.<br />
                                Legen Sie die Standardvoreinstellung fest.</Trans>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', pt: 2 }}>
                            <Typography>
                                <Trans i18nKey="enableFlexTimeAccount" ns="instituteConfigurationPage"><strong>Voreinstellung:</strong> Standardmäßig Arbeitszeitkonto aktivieren.</Trans>
                            </Typography>
                            <Switch
                                checked={institute?.allowFlexTimeAccountsDefault || false}
                                onChange={(e) => handleSwitchAllowFlexTimeAccountsDefault(e.target.checked)}
                            />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
};

export default EditFlexTimeAccountPage
